export const prod = import.meta.env.VITE_APP_PROD === 'true';

export const serverURL = prod ? 'https://myaifrontdeskadmin.com' : 'http://localhost:8080';
